export * from './select-color.component';
export * from './select-color.module';
